import { Medicament } from "./medicament";
import { Consultation } from "./consultation";
import { Prescription } from "./prescription";
import { StockClient } from "./stock-client";

export class Ordonnance {
    ordonnance_id:any;
	ordonnance_etat:any;
/*	ordonnance_notice:any;	
	ordonnance_observation:any;
	ordonnnace_existe_non_existe:any;
	ordonnance_consomme_apres:any;
	ordonnance_consomme_avant:any;
	ordonnance_consomme_pandant:any;
	ordonnance_quantite_medicament:any;*/

	petit_client_id : String;
	ordonnance_notice :any;
	ordonnance_date :Date;
	consultation_id : any;
	ordonnance_conseil : any;
	consultation:Consultation;
	stockClient:StockClient;
	medicament:Medicament;
    prescriptions : Array<Prescription>=new Array<Prescription>();
	constructor($ordonnance_id:any,
		// $ordonnance_etat:any,
		// $ordonnance_notice:any,	
		// $ordonnance_observation:any,
		// $ordonnnace_existe_non_existe:any,
		// $ordonnance_consomme_apres:any,
		// $ordonnance_consomme_avant:any,
		// $ordonnance_consomme_pandant:any,
		// $ordonnance_quantite_medicament:any,
		$consultation:Consultation,
		$stockClient:StockClient,
		$medicament:Medicament){
			this.ordonnance_id = $ordonnance_id;
			// this.ordonnance_etat = $ordonnance_etat;
			// this.ordonnance_notice =$ordonnance_notice;
			this.stockClient = $stockClient;
			this.consultation = $consultation;
			this.medicament = $medicament;
	}
}
